import {createTheme} from '@mui/material/styles';

const theme = createTheme({
  direction: "rtl",
  palette: {
    primary: {
      light: '#07BBA6',
      main: '#07BBA6',
      dark: '#07BBA6',
      contrastText: '#FFFFFF',
      error: '#F16063'
    },
    secondary: {
      light: '#E7E9EE',
      main: '#E7E9EE',
      dark: '#E7E9EE',
      contrastText: '#FFFFFF',
      error: '#F16063'
    },
  },
  typography: {
    fontFamily: [
      'Assistant',
      '-apple-system',
      'BlinkMacSystemFont',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
});

export default theme;
